import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogSectionComponent } from './blog-section.component';

const routes: Routes = [{ path: '', component: BlogSectionComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogSectionRoutingModule { }
